module.exports = __webpack_public_path__ + "static/hero-bg-7fdb8330418d537caa7d447c77e5428d.png";